import {
  Icon,
  theme,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from 'design-system';
import React from 'react';

const passwordRequirements = [
  'Password must be between 8 and 26 characters',
  'Password cannot contain blank spaces',
  'Password must include at least one uppercase letter',
  'Password must include at least one number',
  'Password must include at least one special character',
];

export const PasswordTooltip: React.FC = () => (
  <>
    <TooltipProvider>
      <TooltipRoot>
        <TooltipTrigger asChild>
          <span
            style={{
              cursor: 'pointer',
              marginLeft: 4,
              color: theme.colors.gray10.value as string,
            }}
            aria-label="Password requirements"
          >
            <Icon name="circleInfo" variant="regular" size="xs" />
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          sideOffset={4}
          style={{
            maxWidth: 260,
            background: theme.colors.blue12.value,
            color: theme.colors.white.value,
            borderRadius: 4,
            padding: 12,
            fontSize: 13,
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
          }}
        >
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {passwordRequirements.map((req, i) => (
              <li
                key={i}
                style={{ fontSize: 13, marginBottom: 4, fontWeight: 600 }}
              >
                {req}
              </li>
            ))}
          </ul>
          <TooltipArrow />
        </TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  </>
);
